import { HOME_SET_VIEW_ROLE } from '@core/constants/actions';
import { HomeViewRole } from '@app/constants/home';
import { HomeState } from '@core/types/state';

const initialState: HomeState = {
  viewRole: null,
};

type HomeSetViewRoleAction = {
  type: typeof HOME_SET_VIEW_ROLE;
  viewRole: HomeViewRole;
};

type HomeAction = HomeSetViewRoleAction;

const home = (
  state: HomeState = initialState,
  action: HomeAction
): HomeState => {
  switch (action.type) {
    case HOME_SET_VIEW_ROLE:
      return {
        ...state,
        viewRole: action.viewRole,
      };
    default:
      return state;
  }
};

export default home;
